import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Alloseqtx= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} display="flex" justifyContent="space-evenly" alignItems="center" padding={5} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
           Hero headline
                <br />
                <Typography component="span" variant="inherit" color="primary">
             Alloseq Tx 17
                </Typography>
              </span>
            }
            subtitle= " AlloSeq® Tx 17 is an innovative NGS HLA typing solution that uses Hybrid Capture Technology, which eliminates the inefficiencies and limitations of traditional Long-Range PCR methods. AlloSeq Tx 17 goes beyond the traditional transplant related loci to consider more transplant associated genes and helps you to identify the best genetic match."
            align="left"
            disableGutter
            titleVariant="h3"
      
          />
          <ul>
            <li>
            	No long-range PCR inefficiencies-and no artifacts or crossovers

            </li>
            <li>
            improved allele balance and reduced dropout rates

            </li>
            <li>
            Easy single tube workflow with early indexing and sample pooling
            </li>
            <li>
            	Expanded gene content enabling the highest level of transplant matching
            </li>
            <li>
            Fast import speed (1min/ sample) and optimized data analysis with AlloSeq Assign® software
            </li>
            <li>
            Allele level resolution with low rates of ambiguity
            </li>
            <li>
            	Maximum coverage of 17 loci including all exons for all genes

            </li>

          </ul>
          <SectionHeader
                ctaGroup={[
                   <Button variant="contained" color="primary" size="large">
                   Quickbook
                    </Button>,
                    <Button variant="outlined" color="primary" size="large">
                    Talk to us
                    </Button>,
                ]}
                align="left"
                disableGutter
                titleVariant="h3"
                />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/Alloseqtx-min_Hw3D42A3z.png"
            alt="Atac"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Alloseqtx.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Alloseqtx;
